// Faking an es6 module that is loaded in the script in the public folder.
// We can't use the npm module since this downloaded code contains licensed code
// that is not available on npm.
const TweenMax = window.TweenMax;

export default TweenMax;
